export function BasePicture(folder) {
  return ({ asset, ext, ...props }) => <picture {...props}>
    <source srcset={`${folder}/${asset}.${ext} 1x`} type={`image/${ext}`} />
    <source srcset={`${folder}/${asset}@2x.${ext} 2x`} type={`image/${ext}`} />
    <source srcset={`${folder}/${asset}@3x.${ext} 3x`} type={`image/${ext}`} />
    <img src={`${folder}/${asset}@3x.${ext}`} />
  </picture>
}
